<template>
  <div>
    <console-user-form console-type="businessSolution" :remote-state="remoteState" @createUser="createUser" :allowNoFleetBookingChannel="true"></console-user-form>
  </div>
</template>

<script>
import ConsoleUserForm from './ConsoleUserForm.vue';

export default {
  name: 'BusinessSolutionForm',
  components: { ConsoleUserForm },
  props: {
    remoteState: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async createUser(user) {
      await this.$store.dispatch('bookingChannelView/showLoader');

      try {
        await this.$store.dispatch('onboarding/createBookingChannelAdmin', {
          ...user,
          bookingChannelId: this.remoteState.bookingChannel.id,
        });
      } catch (e) {
        await this.$store.dispatch('bookingChannelView/hideLoader');
        throw e;
      }

      await this.$store.dispatch('bookingChannelView/refreshRemoteState', {
        bookingChannelId: this.remoteState.bookingChannel.id,
      });
    },
  },
};
</script>

<style scoped>

</style>
